/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PetProfileAvatarModel
 */
export interface PetProfileAvatarModel {
    /**
     * 
     * @type {number}
     * @memberof PetProfileAvatarModel
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PetProfileAvatarModel
     */
    imageSource?: PetProfileAvatarModelImageSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof PetProfileAvatarModel
     */
    imageUri?: string;
}


/**
 * @export
 */
export const PetProfileAvatarModelImageSourceEnum = {
    Content: 'CONTENT',
    Photo: 'PHOTO'
} as const;
export type PetProfileAvatarModelImageSourceEnum = typeof PetProfileAvatarModelImageSourceEnum[keyof typeof PetProfileAvatarModelImageSourceEnum];


/**
 * Check if a given object implements the PetProfileAvatarModel interface.
 */
export function instanceOfPetProfileAvatarModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PetProfileAvatarModelFromJSON(json: any): PetProfileAvatarModel {
    return PetProfileAvatarModelFromJSONTyped(json, false);
}

export function PetProfileAvatarModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PetProfileAvatarModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'imageSource': !exists(json, 'imageSource') ? undefined : json['imageSource'],
        'imageUri': !exists(json, 'imageUri') ? undefined : json['imageUri'],
    };
}

export function PetProfileAvatarModelToJSON(value?: PetProfileAvatarModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'imageSource': value.imageSource,
        'imageUri': value.imageUri,
    };
}

